<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">国内配送パターン検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_PATTERN_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn to="/M0201/new" v-permit.SHARP_PATTERN_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_PATTERN_EDIT.SHARP_PATTERN_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-permit.SHARP_PATTERN_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                clearable
                label="配送パターン"
                v-model="query.pattern"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-autocomplete
                :items="places"
                clearable
                item-text="displayText"
                label="発地"
                return-object
                v-model="departurePlace"
              ></v-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                clearable
                label="経由場所"
                url="warehouses/kv"
                v-model="query.transitWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                clearable
                label="最終納入場所"
                url="warehouses/kv"
                v-model="query.destinationWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-select
                :filter="(p) => p.isCharter || p.isDrake || p.isMixLoading"
                item-text="ja_JP"
                item-value="id"
                label="搬送サービス１"
                url="charge-item-sub-type"
                v-model="query.deliveryMode1"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="配送業者１"
                url="companies/transport/kv"
                v-model="query.deliverySupplier1Id"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    label="適用終了日"
                    v-model="query.start"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.start"
                    label="~"
                    v-model="query.end"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.code }} {{ props.item.name }}</td>
          <td>
            {{
              props.item.departurePortName
                ? props.item.departurePortName
                : props.item.departureWarehouseName
            }}
          </td>
          <td>{{ props.item.departureWorkName }}</td>
          <td>
            {{
              props.item.departureSupplierCode +
              ':' +
              props.item.departureSupplierName
            }}
          </td>
          <td>
            {{ props.item.delivery1Code + ':' + props.item.delivery1Name }}
          </td>
          <td>{{ props.item.deliveryModel1Name }}</td>
          <td>{{ props.item.deliverySpecial1Name }}</td>
          <td>{{ props.item.transitWarehouseName }}</td>
          <td>{{ props.item.transitWorkName }}</td>
          <td>
            {{
              props.item.transitSupplierCode +
              ':' +
              props.item.transitSupplierName
            }}
          </td>
          <td>
            {{ props.item.delivery2Code + ':' + props.item.delivery2Name }}
          </td>
          <td>{{ props.item.deliveryModel2Name }}</td>
          <td>{{ props.item.deliverySpecial2Name }}</td>
          <td>{{ props.item.destinationWarehouseName }}</td>
          <td>{{ props.item.destinationWorkName }}</td>
          <td>
            {{
              props.item.destinationSupplierCode +
              ':' +
              props.item.destinationSupplierName
            }}
          </td>
          <td>{{ props.item.endDate }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {},
  data: () => ({
    query: {},

    items: [],
    selected: [],
    results: [],
    loading: false,
    pagination: {
      page: 1,
    },

    departurePlace: null,
    places: [],
    headers: [
      { text: '配送パターン', value: 'code', sortable: false },
      { text: '発地', value: 'departurePlace', sortable: false },
      { text: '発地作業', value: 'departureChargeItem', sortable: false },
      { text: '作業業者', value: 'departureSupplier', sortable: false },
      { text: '配送業者１', value: 'delivery1', sortable: false },
      { text: '搬送サービス１', value: 'deliveryModel1', sortable: false },
      { text: 'SPECIAL1', value: 'deliverySpecial1', sortable: false },
      { text: '経由場所', value: 'transitWarehouse', sortable: false },
      { text: '経由作業', value: 'transitSupplier', sortable: false },
      { text: '作業業者', value: 'transitSupplier', sortable: false },
      { text: '配送業者2', value: 'delivery2', sortable: false },
      { text: '搬送サービス2', value: 'deliveryModel2', sortable: false },
      { text: 'SPECIAL2', value: 'deliverySpecial2', sortable: false },
      { text: '最終納入場所', value: 'destWarehouse', sortable: false },
      { text: '納入作業', value: 'destChargeItem', sortable: false },
      { text: '作業業者', value: 'destSupplier', sortable: false },
      { text: '適用終了日', value: 'endDate', sortable: false },
    ],
  }),
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/patterns', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    edit() {
      this.$router.push({
        name: 'M0201Edit',
        //params: this.selected[0]
        query: { id: this.selected[0].code },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/patterns/${s.code}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    },
  },
  created() {
    Promise.all([
      this.$http.get('/ports/kv'),
      this.$http.get('/warehouses/kv'),
    ]).then(([p, w]) => {
      this.places = [
        ...p.data.map((i) => ({
          ...i,
          type: 'port',
          displayText: i.value + (i.text ? ' [' + i.text + ']' : ''),
        })),
        ...w.data.map((i) => ({
          ...i,
          type: 'warehouse',
          displayText: i.value + (i.text ? ' [' + i.text + ']' : ''),
        })),
      ]
    })
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
    departurePlace(val) {
      if (val && val.value) {
        this.query.departure = val.value
        this.query.departureType = val.type
      } else {
        delete this.query.departure
        delete this.query.departureType
      }
    },
  },
  mounted() {
    this.$loadParams()
  },
}
</script>
